/**
 * Art-deco horizontal divider with a centered diamond glyph.
 * The `bg` prop should match the background color of the section
 * the divider sits against, so the diamond's matte stays seamless.
 */
export interface DividerProps {
  bg?: string;
}

export function Divider({ bg = '#0a1a2a' }: DividerProps) {
  return (
    <div
      role="separator"
      aria-hidden="true"
      style={{
        position: 'relative',
        height: 2,
        background:
          'linear-gradient(to right, transparent 0%, #C19A6B 15%, #cfa020 50%, #C19A6B 85%, transparent 100%)',
        margin: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          color: '#cfa020',
          fontSize: 10,
          backgroundColor: bg,
          padding: '0 6px',
          lineHeight: 1,
        }}
      >
        ◆
      </span>
    </div>
  );
}
